import {
  GetCode,
  UserMobileLogin,
  GetUserOverview,
  GetUserTrend,
  GetUserPro,
  GetUserInfo,
  GetUserStaff,
  GetScanConfig,
  SetUserInfo,
  SetScanConfig,
  StaffRecharge,
  GetUserMoneyRecord,
  ResetPassword,
  GetWechatUserInfo,
  DingTalkLogin
} from "../../api/user";
import { resolve } from "any-promise";
export default {
  state: {
    user: {}
  },
  getters: {
    user: state => state.user
  },
  actions: {
    setUser({ commit }, payload) {
      commit("setUser", payload);
    },
    GetCode({ commit }, payload) {
      return new Promise(resolve => {
        GetCode(payload).then(res => {
          resolve(res);
        });
      });
    },
    UserMobileLogin({ commit }, payload) {
      return new Promise(resolve => {
        UserMobileLogin(payload).then(res => {
          resolve(res);
        });
      });
    },
    GetUserOverview({ commit }, payload) {
      return new Promise(resolve => {
        GetUserOverview(payload).then(res => {
          resolve(res);
        });
      });
    },
    GetUserTrend({ commit }, payload) {
      return new Promise(resolve => {
        GetUserTrend(payload).then(res => {
          resolve(res);
        });
      });
    },
    GetUserPro({ commit }, payload) {
      return new Promise(resolve => {
        GetUserPro(payload).then(res => {
          resolve(res);
        });
      });
    },
    GetUserInfo({ commit }, payload) {
      return new Promise(resolve => {
        GetUserInfo(payload).then(res => {
          resolve(res);
        });
      });
    },
    GetUserStaff({ commit }, payload) {
      return new Promise(resolve => {
        GetUserStaff(payload).then(res => {
          resolve(res);
        });
      });
    },
    GetScanConfig({ commit }, payload) {
      return new Promise(resolve => {
        GetScanConfig(payload).then(res => {
          resolve(res);
        });
      });
    },
    SetUserInfo({ commit }, payload) {
      return new Promise(resolve => {
        SetUserInfo(payload).then(res => {
          resolve(res);
        });
      });
    },
    SetScanConfig({ commit }, payload) {
      return new Promise(resolve => {
        SetScanConfig(payload).then(res => {
          resolve(res);
        });
      });
    },
    StaffRecharge({ commit }, payload) {
      return new Promise(resolve => {
        StaffRecharge(payload).then(res => {
          resolve(res);
        });
      });
    },
    SetPassword({ commit }, payload) {
      return new Promise(resolve => {
        SetPassword(payload).then(res => {
          resolve(res);
        });
      });
    },
    GetUserMoneyRecord({commit},payload){
      return new Promise(resolve => {
        GetUserMoneyRecord(payload).then(res => {
          resolve(res);
        });
      });
    },
    ResetPassword({commit},payload){
      return new Promise(resolve => {
        ResetPassword(payload).then(res => {
          resolve(res);
        });
      });
    },
    GetWechatUserInfo({commit},payload){
      return new Promise(resolve => {
        GetWechatUserInfo(payload).then(res => {
          resolve(res);
        });
      });
    },
    DingTalkLogin({commit},payload){
      return new Promise(resolve => {
        DingTalkLogin(payload).then(res => {
          resolve(res);
        });
      });
    }
  },
  mutations: {
    setUser(state, payload) {
      sessionStorage.user = JSON.stringify(payload);
      state.user = payload;
    }
  }
};
